import React, { useState, useRef, useEffect, useContext } from 'react';
import { useParams } from 'react-router';
import { DataObjectContainer, DataSource } from '../dataObjects/DataObjectContextManager';
import { PageableList } from '../dataObjects/BoundControls';
import { Card } from '../core/Card';
import { ApplicationInfo } from '../components/ApplicationInfo';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';
import { Upload, Trash, Edit, XSquare } from 'react-feather';
import { Popup, Confirmation } from '../core/Popup';
import { CapabilitiesContext } from '../infrastructure/Contexts';
import { CapabilityName } from '../infrastructure/Constants';
import { UserContext } from '../infrastructure/Contexts';

export const ImagePage = () => {

    const context = useRef(null);
    const { applicationKey, source } = useParams();    
    const popup = useRef(null);
    const confirmation = useRef(null);
    const list = useRef(null);    
    const [categories, setCategories] = useState(null);
    const [imageMetaData, setImageMetaData] = useState(null);
    const capabilities = useContext(CapabilitiesContext);
    const loader = capabilities.getCapability(CapabilityName.Loader);
    const userContext = useContext(UserContext);

    if (source.toLowerCase() != userContext.cultureString.toLowerCase()) {
        document.location = '/account/signout';
    }

    useEffect(() => {
        loadCategories();
    }, []);

    const loadCategories = async () => {
        setCategories(null);
        var dataSource = new DataSource("DistinctApplicationImageCategories");
        var items = await dataSource.getItems({ applicationclientid: applicationKey, sourceculture: source });
        console.log('items', items);
        setCategories(items);
    }

    const onImageClick = (data) => {
        setImageMetaData(data);
        popup.current.show();
    }

    const onDeleteClick = (data) => {

        confirmation.current.show('Do you want to delete this image category?', 'Delete',
            async () => {
                console.log(data.id);
                var dataAcess = new ApiDataAccess('api/dataobjects/applicationImageDataObject');                
                await dataAcess.delete(`/application/${applicationKey}/sourceCulture/${source}/category/${data.id}`);
                await loadCategories();
            });
    }

    return (
        <div>
            <ApplicationInfo applicationKey={applicationKey} />

            <Popup ref={popup} closeOnClickAway={ true }>
                <ImageMetaDataPopupContent data={imageMetaData} popup={popup} />
            </Popup>

            <Confirmation ref={confirmation} />

            <DataObjectContainer ref={context} dataObjectName={'applicationImageDataObject'} >

                {categories &&
                    <div>                        
                        {categories.map((category, idx) => {
                            return (
                                <Card key={`card${idx}`} title={category.name} subtitle='The following images are available'>    

                                    <button className='btn btn-primary pull-right' onClick={() => { onDeleteClick(category) }}><Trash className='icon' /><span className='text'>Delete</span></button>

                                    <PageableList key={`list${idx}`} className={'imageList'} pageSize={20} ref={list} filter={{ applicationclientid: applicationKey, sourceculture: source, category: category.id }}
                                        onRenderRow={(key, item, references) => {
                                            return (
                                                <Image id={`image_${key}`} key={key} itemKey={key} item={item} onUploaded={() => { list.current.refresh() }} onClick={info => { onImageClick(info); } } />
                                            )
                                        }} />
                                </Card>
                                )
                        })}
                    </div>
                }

            </DataObjectContainer>            
        </div>
    );
}

export const ImageMetaDataPopupContent = ({ data, popup }) => {

    return (
        <div>
            <div className='topSection'>
                <div className='left'></div>
                <div className='center'><h4>{data.name}</h4></div>
                <div className='right'><XSquare className='icon btn-close clickable' onClick={() => { popup.current.close() }} /></div>
            </div>

            <div className='contentSection'>
                <img src={data.url} />

                <label>Url</label>
                <p><a href={data.url} download>{data.url}</a></p>

                <label>Name</label>
                <p>{data.name}</p>

                <label>File Size</label>
                <p>{data.fileSizeInKb} kb</p>
                
                <label>Type</label>
                <p>{data.contentType}</p>

                <label>Format</label>
                <p>{data.pixelFormat}</p>

                <label>Dimensions (Width x Height)</label>
                <p>{data.width} x {data.height} Pixels</p>

                <label>Resolution (Vertical x Horizontal)</label>
                <p>{data.horizontalResolution} x {data.verticalResolution} DPI</p>

            </div>

        </div>
        )
}


export const Image = ({ id, className, itemKey, item, width, height, onUploaded, onClick }) => {
    const buttonId = `btnUpload_${id}`;
    const [image, setImage] = useState(item.imageId ? item.imageId : null);
    const capabilities = useContext(CapabilitiesContext);
    const loader = capabilities.getCapability(CapabilityName.Loader);


    const onFileSelectClick = () => {
        document.getElementById(buttonId).click();
    }

    const onUploadClick = async (event) => {
        try {
            loader.show();
            setImage(null);
            var file = event.target.files[0];
            var id = image
                ? await updateImage(image, file)
                : await insertImage(file);

            setImage(id);

            if (onUploaded) {
                onUploaded();
            }
        }
        catch (ex) {
            console.log(ex);
            alert('error');
        }

        loader.hide();
    }

    const insertImage = async (file) => {

        const payload = new FormData();
        payload.append('formFile', file);

        var response = await fetch('api/images', { method: "POST", body: payload });
        item.imageId = await response.json();

        var request = {
            method: "PUT",
            body: JSON.stringify(item),
            headers: { "Content-Type": "application/json; charset=utf-8", "Accept-Language": "*" }
        }

        var response = await fetch(`/api/dataobjects/ApplicationImageDataObject/${itemKey}`, request);
        return item.imageId;
    }

    const updateImage = async (id, file) => {

        const payload = new FormData();
        payload.append('formFile', file);

        var response = await fetch(`api/images/${id}`, { method: "PUT", body: payload });
        item.imageId = await response.json();

        var request = {
            method: "PUT",
            body: JSON.stringify(item),
            headers: { "Content-Type": "application/json; charset=utf-8", "Accept-Language": "*" }
        }

        var response = await fetch(`/api/dataobjects/ApplicationImageDataObject/${itemKey}`, request);
        return item.imageId;
    }

    const onDeleteImageClick = async () => {
        loader.show();
        var request = {
            method: "DELETE",
            body: {},
            headers: { "Content-Type": "application/json; charset=utf-8", "Accept-Language": "*" }
        }

        var response = await fetch(`/api/dataobjects/ApplicationImageDataObject/${itemKey}`, request);
        setImage(null);

        if (onUploaded) {
            onUploaded();
        }
        loader.hide();
    }

    const onImageClick = async (id) => {
        if (onClick) {
            loader.show();
            var dataAccess = new ApiDataAccess('/api/images');
            var data = await dataAccess.get(`/metadata/${id}`);
            console.log(data);
            onClick(data);
            loader.hide();
        }        
    }

    return (
        <div>

            <div id={id} className={className ? `imageUpload buttonTile ${className}` : 'imageUpload buttonTile'} style={{ width: width ? width : 280, height: height ? height : 400 }}>

                <div className={'content clickable'}>

                    <div className='imageContainer'>
                        <div className='image'>
                            {image && 
                                <img src={`/api/images/manage/${image}`} onClick={() => { onImageClick(image); }} />
                            }
                        </div>
                        <div>{item.description}</div>
                    </div>


                    <br />

                    <br />
                    <input className='display-none' id={buttonId} type="file" accept=".jpg,.png,.gif" name="myImage" onChange={onUploadClick} />
                </div>

                <div className='footer'>
                    {image
                        ? <div className='btns'>
                            <button className='btn btn-primary' onClick={onDeleteImageClick}><Trash className='icon' />{'Delete'}</button>
                            <button className='btn btn-secondary' onClick={onFileSelectClick}><Edit className='icon' />{'Edit'}</button>
                        </div>
                        : <button className='btn btn-secondary' onClick={onFileSelectClick}><Upload className='icon' />{'Upload'}</button>
                    }
                </div>

            </div>

        </div>
    );
};